import { Box, Switch, TextField, Typography, InputAdornment, IconButton } from "@mui/material";
import { OpenInNew } from "@mui/icons-material";
import dayjs from "dayjs";
import { updateStateObjectData } from "../../../utility/Common";
import { GameCssStyles } from "../../GameManagement/GameCssStyles";
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
dayjs.extend(customParseFormat);

const CommonEntityStats = ({
    editableEntityData,
    setEditableEntityData,
    global_constant,
    type,
    artistType,
    artists,
    genre,
    artist,
    movie,
    song,
    video,
    reel,
    influencers,
}) => {
    const handleOpenUrl = (url) => {
        if (url && (url.startsWith('http://') || url.startsWith('https://'))) {
            window.open(url, '_blank', 'noopener,noreferrer');
        } else if (url) {
            window.open(`https://${url}`, '_blank', 'noopener,noreferrer');
        }
    };

    return (
        <>
            {/* {genre && <TextField
                fullWidth
                label="Genre"
                rows={1}
                value={editableEntityData?.metadata?.stats?.genre || ''}
                onChange={(e) => updateStateObjectData(editableEntityData, setEditableEntityData, "metadata.stats.genre", e.target.value)}
                sx={GameCssStyles.formMultiLineTextField_sx}
            />} */}

            {artist && <>
                {(artistType === 'actor' || artistType === 'actress') &&
                    <>
                        <Box sx={styles.containerStyleRowWithoutBorderNoColor_sx}>
                            <TextField
                                fullWidth
                                label="Debut Movie"
                                rows={1}
                                value={editableEntityData?.metadata?.stats?.debutMovie || ''}
                                onChange={(e) =>
                                    updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.debutMovie`, e.target.value)
                                }
                                sx={GameCssStyles.formSingleLineTextField_sx}
                            />
                            <TextField
                                fullWidth
                                label="Debut Year"
                                rows={1}
                                value={editableEntityData?.metadata?.stats?.debutYear || ''}
                                onChange={(e) =>
                                    updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.debutYear`, e.target.value)
                                }
                                sx={GameCssStyles.formSingleLineTextField_sx}
                            />
                        </Box>
                        <Box sx={styles.containerStyleRowWithoutBorderNoColor_sx}>
                            <TextField
                                fullWidth
                                label="Recent Movie"
                                rows={1}
                                value={editableEntityData?.metadata?.stats?.recentMovie || ''}
                                onChange={(e) =>
                                    updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.recentMovie`, e.target.value)
                                }
                                sx={GameCssStyles.formSingleLineTextField_sx}
                            />
                            <TextField
                                fullWidth
                                label="Upcoming Movie"
                                rows={1}
                                value={editableEntityData?.metadata?.stats?.upcomingMovie || ''}
                                onChange={(e) =>
                                    updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.upcomingMovie`, e.target.value)
                                }
                                sx={GameCssStyles.formSingleLineTextField_sx}
                            />
                            <TextField
                                fullWidth
                                label="Milestone Movies"
                                rows={1}
                                value={editableEntityData?.metadata?.stats?.majorMovie || ''}
                                onChange={(e) =>
                                    updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.majorMovie`, e.target.value)
                                }
                                sx={GameCssStyles.formSingleLineTextField_sx}
                            />
                        </Box>
                        <Box sx={styles.containerStyleRowWithoutBorderNoColor_sx}>
                            <TextField
                                fullWidth
                                label="Major Award"
                                rows={1}
                                value={editableEntityData?.metadata?.stats?.majorAward || ''}
                                onChange={(e) =>
                                    updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.majorAward`, e.target.value)
                                }
                                sx={GameCssStyles.formSingleLineTextField_sx}
                            />
                            <TextField
                                fullWidth
                                label="Youtube URL"
                                multiline={false}
                                rows={1}
                                value={editableEntityData?.metadata?.stats?.ytUrl || ''}
                                onChange={(e) => updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.ytUrl`, e.target.value)}
                                onDoubleClick={() => editableEntityData?.metadata?.stats?.ytUrl && handleOpenUrl(editableEntityData?.metadata?.stats?.ytUrl)}
                                sx={{ ...GameCssStyles.formSingleLineTextField_sx, '& input': { cursor: editableEntityData?.metadata?.stats?.ytUrl ? 'text' : 'default' } }}
                                InputProps={{
                                    endAdornment: editableEntityData?.metadata?.stats?.ytUrl ? (
                                        <InputAdornment position="end">
                                            <IconButton
                                                edge="end"
                                                onClick={() => handleOpenUrl(editableEntityData?.metadata?.stats?.ytUrl)}
                                                sx={{ cursor: 'pointer' }}
                                                title="Open URL in browser"
                                            >
                                                <OpenInNew fontSize="small" />
                                            </IconButton>
                                        </InputAdornment>
                                    ) : null,
                                }}
                            />
                        </Box>
                    </>}
                {(artistType === 'singer' || artistType === 'music_director') &&
                    <>
                        <Box sx={styles.containerStyleRowWithoutBorderNoColor_sx}>
                            <TextField
                                fullWidth
                                label="First Song"
                                rows={1}
                                value={editableEntityData?.metadata?.stats?.firstSong || ''}
                                onChange={(e) =>
                                    updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.firstSong`, e.target.value)
                                }
                                sx={GameCssStyles.formSingleLineTextField_sx}
                            />
                            <TextField
                                fullWidth
                                label="First Song Year"
                                rows={1}
                                value={editableEntityData?.metadata?.stats?.firstSongYear || ''}
                                onChange={(e) =>
                                    updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.firstSongYear`, e.target.value)
                                }
                                sx={GameCssStyles.formSingleLineTextField_sx}
                            />
                            <TextField
                                fullWidth
                                label="Upcoming Releases"
                                rows={1}
                                value={editableEntityData?.metadata?.stats?.upcomingReleases || ''}
                                onChange={(e) =>
                                    updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.upcomingReleases`, e.target.value)
                                }
                                sx={GameCssStyles.formSingleLineTextField_sx}
                            />
                        </Box>
                        <Box sx={styles.containerStyleRowWithoutBorderNoColor_sx}>
                            <TextField
                                fullWidth
                                label="Highest Streaming Song"
                                rows={1}
                                value={editableEntityData?.metadata?.stats?.highestStreamingSong || ''}
                                onChange={(e) =>
                                    updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.highestStreamingSong`, e.target.value)
                                }
                                sx={GameCssStyles.formSingleLineTextField_sx}
                            />
                            <TextField
                                fullWidth
                                label="Highest Streaming Album"
                                rows={1}
                                value={editableEntityData?.metadata?.stats?.highestStreamingAlbum || ''}
                                onChange={(e) =>
                                    updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.highestStreamingAlbum`, e.target.value)
                                }
                                sx={GameCssStyles.formSingleLineTextField_sx}
                            />
                        </Box>

                        <Box sx={styles.containerStyleRowWithoutBorderNoColor_sx}>
                            <TextField
                                fullWidth
                                label="Spotify Highlights"
                                rows={1}
                                value={editableEntityData?.metadata?.stats?.spotifyHighlights || ''}
                                onChange={(e) =>
                                    updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.spotifyHighlights`, e.target.value)
                                }
                                sx={GameCssStyles.formSingleLineTextField_sx}
                            />
                            <TextField
                                fullWidth
                                label="Major Awards"
                                rows={1}
                                value={editableEntityData?.metadata?.stats?.majorAwards || ''}
                                onChange={(e) =>
                                    updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.majorAwards`, e.target.value)
                                }
                                sx={GameCssStyles.formSingleLineTextField_sx}
                            />
                            <TextField
                                fullWidth
                                label="Youtube URL"
                                multiline={false}
                                rows={1}
                                value={editableEntityData?.metadata?.stats?.ytUrl || ''}
                                onChange={(e) => updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.ytUrl`, e.target.value)}
                                onDoubleClick={() => editableEntityData?.metadata?.stats?.ytUrl && handleOpenUrl(editableEntityData?.metadata?.stats?.ytUrl)}
                                sx={{ ...GameCssStyles.formSingleLineTextField_sx, '& input': { cursor: editableEntityData?.metadata?.stats?.ytUrl ? 'text' : 'default' } }}
                                InputProps={{
                                    endAdornment: editableEntityData?.metadata?.stats?.ytUrl ? (
                                        <InputAdornment position="end">
                                            <IconButton
                                                edge="end"
                                                onClick={() => handleOpenUrl(editableEntityData?.metadata?.stats?.ytUrl)}
                                                sx={{ cursor: 'pointer' }}
                                                title="Open URL in browser"
                                            >
                                                <OpenInNew fontSize="small" />
                                            </IconButton>
                                        </InputAdornment>
                                    ) : null,
                                }}
                            />
                        </Box>
                    </>}
                {(artistType === 'director' || artistType === 'producer') &&
                    <>
                        <Box sx={styles.containerStyleRowWithoutBorderNoColor_sx}>
                            <TextField
                                fullWidth
                                label="Debut Movie"
                                rows={1}
                                value={editableEntityData?.metadata?.stats?.debutMovie || ''}
                                onChange={(e) =>
                                    updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.debutMovie`, e.target.value)
                                }
                                sx={GameCssStyles.formSingleLineTextField_sx}
                            />
                        </Box>
                        <Box sx={styles.containerStyleRowWithoutBorderNoColor_sx}>
                            <TextField
                                fullWidth
                                label="Major Award"
                                rows={1}
                                value={editableEntityData?.metadata?.stats?.majorAward || ''}
                                onChange={(e) =>
                                    updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.majorAward`, e.target.value)
                                }
                                sx={GameCssStyles.formSingleLineTextField_sx}
                            />
                        </Box>
                        <Box sx={styles.containerStyleRowWithoutBorderNoColor_sx}>
                            <TextField
                                fullWidth
                                label="Milestone Movies"
                                rows={1}
                                value={editableEntityData?.metadata?.stats?.milestoneMovies || ''}
                                onChange={(e) =>
                                    updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.milestoneMovies`, e.target.value)
                                }
                                sx={GameCssStyles.formSingleLineTextField_sx}
                            />
                        </Box>
                        <Box sx={styles.containerStyleRowWithoutBorderNoColor_sx}>
                            <TextField
                                fullWidth
                                label="Upcoming Movies"
                                rows={1}
                                value={editableEntityData?.metadata?.stats?.upcomingMovies || ''}
                                onChange={(e) =>
                                    updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.upcomingMovies`, e.target.value)
                                }
                                sx={GameCssStyles.formSingleLineTextField_sx}
                            />
                            <TextField
                                fullWidth
                                label="Youtube URL"
                                multiline={false}
                                rows={1}
                                value={editableEntityData?.metadata?.stats?.ytUrl || ''}
                                onChange={(e) => updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.ytUrl`, e.target.value)}
                                onDoubleClick={() => editableEntityData?.metadata?.stats?.ytUrl && handleOpenUrl(editableEntityData?.metadata?.stats?.ytUrl)}
                                sx={{ ...GameCssStyles.formSingleLineTextField_sx, '& input': { cursor: editableEntityData?.metadata?.stats?.ytUrl ? 'text' : 'default' } }}
                                InputProps={{
                                    endAdornment: editableEntityData?.metadata?.stats?.ytUrl ? (
                                        <InputAdornment position="end">
                                            <IconButton
                                                edge="end"
                                                onClick={() => handleOpenUrl(editableEntityData?.metadata?.stats?.ytUrl)}
                                                sx={{ cursor: 'pointer' }}
                                                title="Open URL in browser"
                                            >
                                                <OpenInNew fontSize="small" />
                                            </IconButton>
                                        </InputAdornment>
                                    ) : null,
                                }}
                            />
                        </Box>
                    </>}
            </>}

            {movie && <>
                <Box sx={styles.containerStyleRowWithoutBorderNoColor_sx}>
                    <TextField
                        fullWidth
                        label="Director"
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.director || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.director`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                    <TextField
                        fullWidth
                        label="Producer"
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.producer || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.producer`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                    <TextField
                        fullWidth
                        label="Production House"
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.productionHouse || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.productionHouse`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                </Box>

                <Box sx={styles.containerStyleRowWithoutBorderNoColor_sx}>
                    <TextField
                        fullWidth
                        label="Actors"
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.actors || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.actors`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                    <TextField
                        fullWidth
                        label="Lead Cast"
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.leadCast || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.leadCast`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                </Box>

                <Box sx={styles.containerStyleRowWithoutBorderNoColor_sx}>
                    <TextField
                        fullWidth
                        label="Awards Won"
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.awardsWon || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.awardsWon`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                    <TextField
                        fullWidth
                        label="Release Date"
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.releaseDate || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.releaseDate`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                    <TextField
                        fullWidth
                        label="Release Year"
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.yearOfRelease || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.yearOfRelease`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                    <TextField
                        fullWidth
                        label="Youtube URL"
                        multiline={false}
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.ytUrl || ''}
                        onChange={(e) => updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.ytUrl`, e.target.value)}
                        onDoubleClick={() => editableEntityData?.metadata?.stats?.ytUrl && handleOpenUrl(editableEntityData?.metadata?.stats?.ytUrl)}
                        sx={{ ...GameCssStyles.formSingleLineTextField_sx, '& input': { cursor: editableEntityData?.metadata?.stats?.ytUrl ? 'text' : 'default' } }}
                        InputProps={{
                            endAdornment: editableEntityData?.metadata?.stats?.ytUrl ? (
                                <InputAdornment position="end">
                                    <IconButton
                                        edge="end"
                                        onClick={() => handleOpenUrl(editableEntityData?.metadata?.stats?.ytUrl)}
                                        sx={{ cursor: 'pointer' }}
                                        title="Open URL in browser"
                                    >
                                        <OpenInNew fontSize="small" />
                                    </IconButton>
                                </InputAdornment>
                            ) : null,
                        }}
                    />
                </Box>

                <Box sx={styles.containerStyleRowWithoutBorderNoColor_sx}>
                    <TextField
                        fullWidth
                        label="Average Weekly Collection"
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.averageWeeklyCollection || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.averageWeeklyCollection`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                    <TextField
                        fullWidth
                        label="Total Collection"
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.totalCollection || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.totalCollection`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                </Box>

                <Box sx={styles.containerStyleRowWithoutBorderNoColor_sx}>
                    <TextField
                        fullWidth
                        label="Genre"
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.genre || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.genre`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                    <TextField
                        fullWidth
                        label="Language"
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.language || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.language`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                </Box>

                <Box sx={styles.containerStyleColumn_sx}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', marginRight: 2, textAlign: 'left' }}>History</Typography>

                    <Box sx={styles.containerStyleRowWithoutBorderNoColor_sx}>
                        <Box sx={styles.containerStyleColumnBordered_sx}>
                            <Typography variant="body1" sx={{ fontWeight: 'bold', alignSelf: 'center', marginRight: 0 }}> Movie #1</Typography>
                            <TextField
                                fullWidth
                                label="Name"
                                rows={1}
                                value={editableEntityData?.metadata?.stats?.history?.history1?.name || ''}
                                onChange={(e) =>
                                    updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.history.history1.name`, e.target.value)
                                }
                                sx={GameCssStyles.formSingleLineTextField_sx}
                            />
                            <TextField
                                fullWidth
                                label="Budget"
                                rows={1}
                                value={editableEntityData?.metadata?.stats?.history?.history1?.budget || ''}
                                onChange={(e) =>
                                    updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.history.history1.budget`, e.target.value)
                                }
                                sx={GameCssStyles.formSingleLineTextField_sx}
                            />
                            <TextField
                                fullWidth
                                label="Collection"
                                rows={1}
                                value={editableEntityData?.metadata?.stats?.history?.history1?.collection || ''}
                                onChange={(e) =>
                                    updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.history.history1.collection`, e.target.value)
                                }
                                sx={GameCssStyles.formSingleLineTextField_sx}
                            />
                            <TextField
                                fullWidth
                                label="Association"
                                rows={1}
                                value={editableEntityData?.metadata?.stats?.history?.history1?.association || ''}
                                onChange={(e) =>
                                    updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.history.history1.association`, e.target.value)
                                }
                                sx={GameCssStyles.formSingleLineTextField_sx}
                            />
                        </Box>

                        <Box sx={styles.containerStyleColumnBordered_sx}>
                            <Typography variant="body1" sx={{ fontWeight: 'bold', alignSelf: 'center', marginRight: 0 }}> Movie #2</Typography>
                            <TextField
                                fullWidth
                                label="Name"
                                rows={1}
                                value={editableEntityData?.metadata?.stats?.history?.history2?.name || ''}
                                onChange={(e) =>
                                    updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.history.history2.name`, e.target.value)
                                }
                                sx={GameCssStyles.formSingleLineTextField_sx}
                            />
                            <TextField
                                fullWidth
                                label="Budget"
                                rows={1}
                                value={editableEntityData?.metadata?.stats?.history?.history1?.budget || ''}
                                onChange={(e) =>
                                    updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.history.history1.budget`, e.target.value)
                                }
                                sx={GameCssStyles.formSingleLineTextField_sx}
                            />
                            <TextField
                                fullWidth
                                label="Collection"
                                rows={1}
                                value={editableEntityData?.metadata?.stats?.history?.history2?.collection || ''}
                                onChange={(e) =>
                                    updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.history.history2.collection`, e.target.value)
                                }
                                sx={GameCssStyles.formSingleLineTextField_sx}
                            />
                            <TextField
                                fullWidth
                                label="Association"
                                rows={1}
                                value={editableEntityData?.metadata?.stats?.history?.history2?.association || ''}
                                onChange={(e) =>
                                    updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.history.history2.association`, e.target.value)
                                }
                                sx={GameCssStyles.formSingleLineTextField_sx}
                            />
                        </Box>

                        <Box sx={styles.containerStyleColumnBordered_sx}>
                            <Typography variant="body1" sx={{ fontWeight: 'bold', alignSelf: 'center', marginRight: 0 }}> Movie #3</Typography>
                            <TextField
                                fullWidth
                                label="Name"
                                rows={1}
                                value={editableEntityData?.metadata?.stats?.history?.history3?.name || ''}
                                onChange={(e) =>
                                    updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.history.history3.name`, e.target.value)
                                }
                                sx={GameCssStyles.formSingleLineTextField_sx}
                            />
                            <TextField
                                fullWidth
                                label="Budget"
                                rows={1}
                                value={editableEntityData?.metadata?.stats?.history?.history1?.budget || ''}
                                onChange={(e) =>
                                    updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.history.history1.budget`, e.target.value)
                                }
                                sx={GameCssStyles.formSingleLineTextField_sx}
                            />
                            <TextField
                                fullWidth
                                label="Collection"
                                rows={1}
                                value={editableEntityData?.metadata?.stats?.history?.history3?.collection || ''}
                                onChange={(e) =>
                                    updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.history.history3.collection`, e.target.value)
                                }
                                sx={GameCssStyles.formSingleLineTextField_sx}
                            />
                            <TextField
                                fullWidth
                                label="Association"
                                rows={1}
                                value={editableEntityData?.metadata?.stats?.history?.history3?.association || ''}
                                onChange={(e) =>
                                    updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.history.history3.association`, e.target.value)
                                }
                                sx={GameCssStyles.formSingleLineTextField_sx}
                            />
                        </Box>
                    </Box>
                </Box>
            </>}

            {song && <>
                <Box sx={styles.containerStyleRowWithoutBorderNoColor_sx}>
                    <TextField
                        fullWidth
                        label="title"
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.title || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.title`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                    <TextField
                        fullWidth
                        label="Year Of Release"
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.yearOfRelease || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.yearOfRelease`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                </Box>
                <Box sx={styles.containerStyleRowWithoutBorderNoColor_sx}>
                    <TextField
                        fullWidth
                        label="Singers"
                        rows={3}
                        value={editableEntityData?.metadata?.stats?.singers || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.singers`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                    <TextField
                        fullWidth
                        label="Actor/Actress"
                        rows={3}
                        value={editableEntityData?.metadata?.stats?.actor_actress || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.actor_actress`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                </Box>
                <Box sx={styles.containerStyleRowWithoutBorderNoColor_sx}>
                    <TextField
                        fullWidth
                        label="Major Awards"
                        rows={3}
                        value={editableEntityData?.metadata?.stats?.majorAwards || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.majorAwards`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                    <TextField
                        fullWidth
                        label="Youtube URL"
                        multiline={false}
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.ytUrl || ''}
                        onChange={(e) => updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.ytUrl`, e.target.value)}
                        onDoubleClick={() => editableEntityData?.metadata?.stats?.ytUrl && handleOpenUrl(editableEntityData?.metadata?.stats?.ytUrl)}
                        sx={{ ...GameCssStyles.formSingleLineTextField_sx, '& input': { cursor: editableEntityData?.metadata?.stats?.ytUrl ? 'text' : 'default' } }}
                        InputProps={{
                            endAdornment: editableEntityData?.metadata?.stats?.ytUrl ? (
                                <InputAdornment position="end">
                                    <IconButton
                                        edge="end"
                                        onClick={() => handleOpenUrl(editableEntityData?.metadata?.stats?.ytUrl)}
                                        sx={{ cursor: 'pointer' }}
                                        title="Open URL in browser"
                                    >
                                        <OpenInNew fontSize="small" />
                                    </IconButton>
                                </InputAdornment>
                            ) : null,
                        }}
                    />
                </Box>
                <Box sx={styles.containerStyleRowWithoutBorderNoColor_sx}>
                    <TextField
                        fullWidth
                        label="Album"
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.album || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.album`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                    <TextField
                        fullWidth
                        label="Composer"
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.composer || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.composer`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                    <TextField
                        fullWidth
                        label="Lyricist"
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.lyricist || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.lyricist`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                </Box>

                <Box sx={styles.containerStyleRowWithoutBorderNoColor_sx}>
                    <TextField
                        fullWidth
                        label="Movie"
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.movie || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.movie`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                    <TextField
                        fullWidth
                        label="Music Composer/Director"
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.musicDirector || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.musicDirector`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                </Box>

                <Box sx={styles.containerStyleRowWithoutBorderNoColor_sx}>
                    <TextField
                        fullWidth
                        label="Current Number of Streams"
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.currentNumberofStreams || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.currentNumberofStreams`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                    <TextField
                        fullWidth
                        label="Last 3 Releases Avg Streams"
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.last3releasesAverageStreams || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.last3releasesAverageStreams`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                </Box>
                <Box sx={styles.containerStyleRowWithoutBorderNoColor_sx}>
                    <TextField
                        fullWidth
                        label="Position On The Playlist"
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.positionOnTheplaylist || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.positionOnTheplaylist`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                    <TextField
                        fullWidth
                        label="Spotify Stats"
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.spotifyStats || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.spotifyStats`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                </Box>

                {/* <Box sx={styles.containerStyleColumn_sx}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', marginRight: 0, textAlign: 'left' }}>History</Typography>

                    <Box sx={styles.containerStyleRowWithoutBorderNoColor_sx}>
                        <TextField
                            fullWidth
                            label="Subscribe"
                            rows={1}
                            value={editableEntityData?.metadata?.stats?.history?.subscribe || ''}
                            onChange={(e) =>
                                updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.history.subscribe`, e.target.value)
                            }
                            sx={GameCssStyles.formSingleLineTextField_sx}
                        />
                        <TextField
                            fullWidth
                            label="Views / Streams"
                            rows={1}
                            value={editableEntityData?.metadata?.stats?.history?.view || ''}
                            onChange={(e) =>
                                updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.history.view`, e.target.value)
                            }
                            sx={GameCssStyles.formSingleLineTextField_sx}
                        />
                        <TextField
                            fullWidth
                            label="Position"
                            rows={1}
                            value={editableEntityData?.metadata?.stats?.history?.position || ''}
                            onChange={(e) =>
                                updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.history.position`, e.target.value)
                            }
                            sx={GameCssStyles.formSingleLineTextField_sx}
                        />
                    </Box>
                </Box> */}
            </>}

            {video && <>
                <Box sx={styles.containerStyleRowWithoutBorderNoColor_sx}>
                    <TextField
                        fullWidth
                        label="Title"
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.title || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.title`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                    <TextField
                        fullWidth
                        label="Release Date"
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.releaseDate || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.releaseDate`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                </Box>
                <Box sx={styles.containerStyleRowWithoutBorderNoColor_sx}>
                    <TextField
                        fullWidth
                        label="Artists"
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.artists || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.artists`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                    <TextField
                        fullWidth
                        label="Genre"
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.genre || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.genre`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                    <TextField
                        fullWidth
                        label="Youtube URL"
                        multiline={false}
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.ytUrl || ''}
                        onChange={(e) => updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.ytUrl`, e.target.value)}
                        onDoubleClick={() => editableEntityData?.metadata?.stats?.ytUrl && handleOpenUrl(editableEntityData?.metadata?.stats?.ytUrl)}
                        sx={{ ...GameCssStyles.formSingleLineTextField_sx, '& input': { cursor: editableEntityData?.metadata?.stats?.ytUrl ? 'text' : 'default' } }}
                        InputProps={{
                            endAdornment: editableEntityData?.metadata?.stats?.ytUrl ? (
                                <InputAdornment position="end">
                                    <IconButton
                                        edge="end"
                                        onClick={() => handleOpenUrl(editableEntityData?.metadata?.stats?.ytUrl)}
                                        sx={{ cursor: 'pointer' }}
                                        title="Open URL in browser"
                                    >
                                        <OpenInNew fontSize="small" />
                                    </IconButton>
                                </InputAdornment>
                            ) : null,
                        }}
                    />
                </Box>
                <Box sx={styles.containerStyleRowWithoutBorderNoColor_sx}>
                    <TextField
                        fullWidth
                        label="Channel Name"
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.channelName || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.channelName`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                    <TextField
                        fullWidth
                        label="Creator Name"
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.creatorName || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.creatorName`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                </Box>
                <Box sx={styles.containerStyleRowWithoutBorderNoColor_sx}>
                    <TextField
                        fullWidth
                        label="Total Channel Subscribers"
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.totalChannelSubscribers || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.totalChannelSubscribers`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                    <TextField
                        fullWidth
                        label="Total Views"
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.totalViews || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.totalViews`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                    <TextField
                        fullWidth
                        label="Trending List Position"
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.trendingListPosition || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.trendingListPosition`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                </Box>

                {/* <Box sx={styles.containerStyleColumn_sx}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', marginRight: 0, textAlign: 'left' }}>History</Typography>

                    <Box sx={styles.containerStyleRowWithoutBorderNoColor_sx}>
                        <TextField
                            fullWidth
                            label="Subscribe"
                            rows={1}
                            value={editableEntityData?.metadata?.stats?.history?.subscribe || ''}
                            onChange={(e) =>
                                updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.history.subscribe`, e.target.value)
                            }
                            sx={GameCssStyles.formSingleLineTextField_sx}
                        />
                        <TextField
                            fullWidth
                            label="Views / Streams"
                            rows={1}
                            value={editableEntityData?.metadata?.stats?.history?.view || ''}
                            onChange={(e) =>
                                updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.history.view`, e.target.value)
                            }
                            sx={GameCssStyles.formSingleLineTextField_sx}
                        />
                        <TextField
                            fullWidth
                            label="Position"
                            rows={1}
                            value={editableEntityData?.metadata?.stats?.history?.position || ''}
                            onChange={(e) =>
                                updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.history.position`, e.target.value)
                            }
                            sx={GameCssStyles.formSingleLineTextField_sx}
                        />
                    </Box>
                </Box> */}
            </>}

            {reel && <>
                <Box sx={styles.containerStyleRowWithoutBorderNoColor_sx}>
                    <TextField
                        fullWidth
                        label="Title"
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.title || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.title`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                    <TextField
                        fullWidth
                        label="Creator Name"
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.creatorName || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.creatorName`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                    <TextField
                        fullWidth
                        label="Date Posted"
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.datePosted || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.datePosted`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                </Box>
                <Box sx={styles.containerStyleRowWithoutBorderNoColor_sx}>
                    <TextField
                        fullWidth
                        label="Genre"
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.genre || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.genre`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                    <TextField
                        fullWidth
                        label="Hash Tags"
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.HashTags || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.HashTags`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                    <TextField
                        fullWidth
                        label="Youtube URL"
                        multiline={false}
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.ytUrl || ''}
                        onChange={(e) => updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.ytUrl`, e.target.value)}
                        onDoubleClick={() => editableEntityData?.metadata?.stats?.ytUrl && handleOpenUrl(editableEntityData?.metadata?.stats?.ytUrl)}
                        sx={{ ...GameCssStyles.formSingleLineTextField_sx, '& input': { cursor: editableEntityData?.metadata?.stats?.ytUrl ? 'text' : 'default' } }}
                        InputProps={{
                            endAdornment: editableEntityData?.metadata?.stats?.ytUrl ? (
                                <InputAdornment position="end">
                                    <IconButton
                                        edge="end"
                                        onClick={() => handleOpenUrl(editableEntityData?.metadata?.stats?.ytUrl)}
                                        sx={{ cursor: 'pointer' }}
                                        title="Open URL in browser"
                                    >
                                        <OpenInNew fontSize="small" />
                                    </IconButton>
                                </InputAdornment>
                            ) : null,
                        }}
                    />
                </Box>
                <Box sx={styles.containerStyleRowWithoutBorderNoColor_sx}>
                    <TextField
                        fullWidth
                        label="Total Followers"
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.totalFollowers || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.totalFollowers`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                    <TextField
                        fullWidth
                        label="Likes Of The Last Reel"
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.likesOfTheLastReel || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.likesOfTheLastReel`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                    <TextField
                        fullWidth
                        label="Comments On The Last Reel"
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.commentsOnTheLastReel || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.commentsOnTheLastReel`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                </Box>

                {/* <Box sx={styles.containerStyleColumn_sx}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', marginRight: 0, textAlign: 'left' }}>History</Typography>

                    <Box sx={styles.containerStyleRowWithoutBorderNoColor_sx}>
                        <TextField
                            fullWidth
                            label="Followers"
                            rows={1}
                            value={editableEntityData?.metadata?.stats?.history?.follower || ''}
                            onChange={(e) =>
                                updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.history.follower`, e.target.value)
                            }
                            sx={GameCssStyles.formSingleLineTextField_sx}
                        />
                        <TextField
                            fullWidth
                            label="Like"
                            rows={1}
                            value={editableEntityData?.metadata?.stats?.history?.like || ''}
                            onChange={(e) =>
                                updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.history.like`, e.target.value)
                            }
                            sx={GameCssStyles.formSingleLineTextField_sx}
                        />
                        <TextField
                            fullWidth
                            label="Comment"
                            rows={1}
                            value={editableEntityData?.metadata?.stats?.history?.comment || ''}
                            onChange={(e) =>
                                updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.history.comment`, e.target.value)
                            }
                            sx={GameCssStyles.formSingleLineTextField_sx}
                        />
                    </Box>
                </Box> */}
            </>}

            {influencers && <>
                <Box sx={styles.containerStyleRowWithoutBorderNoColor_sx}>
                    <TextField
                        fullWidth
                        label="Name"
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.name || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.name`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                    <TextField
                        fullWidth
                        label="Platform"
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.platform || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.platform`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                    <TextField
                        fullWidth
                        label="Genre"
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.genre || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.genre`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                </Box>
                <Box sx={styles.containerStyleRowWithoutBorderNoColor_sx}>
                    <TextField
                        fullWidth
                        label="Active Since"
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.activeSince || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.activeSince`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                    <TextField
                        fullWidth
                        label="Date of Last Post"
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.dateOfLastPost || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.dateOfLastPost`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                    <TextField
                        fullWidth
                        label="Youtube URL"
                        multiline={false}
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.ytUrl || ''}
                        onChange={(e) => updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.ytUrl`, e.target.value)}
                        onDoubleClick={() => editableEntityData?.metadata?.stats?.ytUrl && handleOpenUrl(editableEntityData?.metadata?.stats?.ytUrl)}
                        sx={{ ...GameCssStyles.formSingleLineTextField_sx, '& input': { cursor: editableEntityData?.metadata?.stats?.ytUrl ? 'text' : 'default' } }}
                        InputProps={{
                            endAdornment: editableEntityData?.metadata?.stats?.ytUrl ? (
                                <InputAdornment position="end">
                                    <IconButton
                                        edge="end"
                                        onClick={() => handleOpenUrl(editableEntityData?.metadata?.stats?.ytUrl)}
                                        sx={{ cursor: 'pointer' }}
                                        title="Open URL in browser"
                                    >
                                        <OpenInNew fontSize="small" />
                                    </IconButton>
                                </InputAdornment>
                            ) : null,
                        }}
                    />
                </Box>
                <Box sx={styles.containerStyleRowWithoutBorderNoColor_sx}>
                    <TextField
                        fullWidth
                        label="Total Followers"
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.totalFollowers || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.totalFollowers`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                    <TextField
                        fullWidth
                        label="Total Likes On Last Post"
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.totalLikesOnLastPost || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.totalLikesOnLastPost`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                    <TextField
                        fullWidth
                        label="Comments On Last Post"
                        rows={1}
                        value={editableEntityData?.metadata?.stats?.commentsOnLastPost || ''}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.commentsOnLastPost`, e.target.value)
                        }
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                </Box>

                {/* <Box sx={styles.containerStyleColumn_sx}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', marginRight: 0, textAlign: 'left' }}>History</Typography>

                    <Box sx={styles.containerStyleRowWithoutBorderNoColor_sx}>
                        <TextField
                            fullWidth
                            label="Post"
                            rows={1}
                            value={editableEntityData?.metadata?.stats?.history?.post || ''}
                            onChange={(e) =>
                                updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.history.post`, e.target.value)
                            }
                            sx={GameCssStyles.formSingleLineTextField_sx}
                        />
                        <TextField
                            fullWidth
                            label="Likes/Views"
                            rows={1}
                            value={editableEntityData?.metadata?.stats?.history?.view || ''}
                            onChange={(e) =>
                                updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.history.view`, e.target.value)
                            }
                            sx={GameCssStyles.formSingleLineTextField_sx}
                        />
                        <TextField
                            fullWidth
                            label="Comment"
                            rows={1}
                            value={editableEntityData?.metadata?.stats?.history?.comment || ''}
                            onChange={(e) =>
                                updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.stats.history.comment`, e.target.value)
                            }
                            sx={GameCssStyles.formSingleLineTextField_sx}
                        />
                    </Box>
                </Box> */}
            </>}
        </>
    );
}

const styles = {
    containerStyleRow_sx: {
        backgroundColor: '#f4f1f9',
        justifyContent: 'center',
        borderRadius: 1,
        border: '1px solid #000000',
        padding: 2,
        display: "flex",
        flex: 1,
        flexDirection: "column",
        gap: 2,
        m: 4
    },
    containerStyleColumn_sx: {
        backgroundColor: '#f4f1f9',
        justifyContent: 'center',
        display: "flex",
        flex: 1,
        flexDirection: "column",
        gap: 2,
    },
    containerStyleColumnBordered_sx: {
        backgroundColor: '#f4f1f9',
        justifyContent: 'center',
        display: "flex",
        flex: 1,
        flexDirection: "column",
        gap: 2,
        borderRadius: 1,
        border: '1px solid #000000',
        padding: 2,

    },
    containerStyleRowWithoutBorderNoColor_sx: {
        //backgroundColor: '#f4f1f9',
        justifyContent: 'center',
        display: "flex",
        flex: 1,
        flexDirection: "row",
        gap: 2
    },
}

export default CommonEntityStats;